export default __webpack_public_path__ + "assets/check-in-start-view-carousel-img/carousel-img-03.ec3455edabd52fe6f55e31c2da3d9598.webp";